let menuSection = document.querySelectorAll('.header__nav .menu-item');
let body = document.querySelector("body");

// for clickable event
menuSection.forEach(v=> {
  v.onclick = (()=> {
   setTimeout(()=> {
      menuSection.forEach(j=> j.classList.remove('active'))
    v.classList.add('active')
  },300)
   })
})

// for window scrolldown event

if( body.classList.contains("home") ) {

  window.onscroll = (()=> {
    let mainSection = document.querySelectorAll('body section');
  
    mainSection.forEach((v,i)=> {
      let rect = v.getBoundingClientRect().y
      if(rect < window.innerHeight-200){
        menuSection.forEach(v=> v.classList.remove('active'))
        menuSection[i].classList.add('active')
      }
      if(window.scrollY==0){
          menuSection.forEach(v=> v.classList.remove('active'))
        }
    })
  })
}
